import * as createjs from "createjs-module";
import * as symConst from 'src/app/shared/constant/canvasSymTypes'; 
//import {stage} from DrawingBoardComponent;
import * as dConst from 'src/app/shared/constant/drawConstants';
//import {CvDrawingBoard} from 'src/assets/js/cv-classes.js'
import {clearProbState, db,stage, cvGetFileDataToSave,cvGetDataUndoPush,
      cvControl,checkPosForPageAdd} from 'src/assets/js/draw.js';
import {findProbEndX, findProbEndY, getSymFont,removeNewLines,countNewLines,convertXYforABCBox,
      findLastProb, doStageUpdate} from 'src/assets/js/cv-helpers.js';


import {STATE_IN_ABC,STATE_ABC_DRAG,STATE_NORMAL,SYM_TYPE_TEXT,STATE_ABC_WRAP, 
        STATE_IN_IPAD_ABC, STATE_VIEW_ONLY_FILE, SymbolText} from 'src/assets/js/cv-classes.js';
import { newTreeSym } from 'src/assets/js/cv-line-entry.js';
import { insertOneNullSym,spliceOneNullSym,moveOverGridText, newDivSymGrid } from "./cv-grid-entry";
import { drawCursor,hideGridShape,makeProbSelected, drawProbShapes} from "./cv-graphics-mouse";
import { startMProb } from "./cv-layout-shared";


/***
 * function display IpadABC is called from the sidebar UI only on tablets that don't have keyboards
 * An entire string is passed in, which is then added to objects as ABC text
 * The routine used to display ABC text on file opens is utilized
 */
export function displayIpadABC(textStr) {

  let blankPage = false;

  if (db.state == STATE_VIEW_ONLY_FILE) { 
    return;
  }

  if (textStr != null) {
    // check that last action wasn't an incomplete abc, and complete if so before moving on
    if (db.probState == STATE_IN_IPAD_ABC) {
      clearProbState();
    }
     
    if (db.curProb == null) {
      cvControl(symConst.CV_CNTL_NEW_PROBLEM);
      blankPage = true;
    }
    // check if within a grid/line problem, and also if 
    // entered text string has newlines or is long - or close to page width - if so, then create new problem so text 
    // will end up going into a text problem that can wrap 
    let lineCount = countNewLines(textStr);
    let maxWidth = ((stage.canvas.width/stage.scaleX)/db.curProb.gridW)*1.6;
 
    if (!blankPage && (db.curProb.displayType != dConst.DISPLAY_TYPE_TEXT &&
        db.curProb.line.length > 1 || db.curLine.sym.length > 0) && 
      (lineCount > 1 || textStr.length > maxWidth)) {
      cvControl(symConst.CV_CNTL_NEW_PROBLEM);
    }

    // initialize the text structures.  The true arguement indicates this is an ipad abc action
    startABCText(true);

    // put the whole string in instead of an individual key.  T
    // This will get completed when the user does any other action, though clearProbState routine
    pressedKey(null, textStr);
    db.probState = STATE_IN_IPAD_ABC; 
    db.fileChanged = true;
    clearProbState()
    
  }
}

export function displayTextFileOpen(fileSym,mFileProb) {

  //console.log(fileSym, " file problem ", mFileProb);

  // create a new text object at db.curText and a container for it
  createNewTextObjs();

  // set up fields specific to displaying text from file open
  db.curText.w = fileSym.size1;
  db.curText.h = fileSym.size2;
  db.curText.wrapStarted = fileSym.flag;
  db.curText.textTyped = fileSym.value;

  // make the createjs text object and draw it
   db.curText.textToDraw = new createjs.Text(db.curText.textTyped, 
                            getSymFont(symConst.KEY_ID_1,symConst.CV_NUM_TYPE),db.userPrefs.cvTextColor);
   db.curText.textToDraw.x = db.curProb.gridW/4; // -db.gridWidth/4;  // check later
   db.curText.textToDraw.y = db.curProb.halfGH;
   db.curText.textToDraw.textAlign = 'left';
   db.curText.textToDraw.textBaseline = 'middle';
   db.curText.textToDraw.mouseEnabled = false;
   db.curText.textToDraw.lineWidth = db.curText.w;
   db.curText.container.addChild(db.curText.textToDraw);
   doStageUpdate();

  // add to text list to manage multiple texts in grid line
  db.curProb.textSymList.push(db.curText);
  db.curLine.sym.splice(db.curLine.sIndex+1,0,db.curText);   
  db.curLine.sIndex++; 

  if ( db.curProb.displayType == dConst.DISPLAY_TYPE_TEXT) {
    db.curProb.width = db.curText.w/db.curProb.gridW;
    drawProbShapes(db.curText.w,db.curText.y);
  }
  else {  // check this
    // figure out if this is the longest line in grid problem that needs ajustment
    if (db.curLine.sIndex+1 >= db.curProb.width) {  // check this
      db.curProb.width++;
    }
    db.xpos += db.curProb.gridW;  // just increment one grid width since null chars will fill rest
    db.curText.box = drawOneABCBox(db.curText.container,db.curText.w, db.curText.h,'grey',dConst.ABC_BOX_INACTIVE_STROKE,"white",0);
    db.curText.box.mouseEnabled = false;               // disable mouse so as to not interferre with problem level drags
    db.curText.container.mouseEnabled = false;
    db.curText.box.visible = false;
  }
  let logInput = new dConst.CanvasInput("abc from file", db.curText.textTyped);
  db.userLog.input.push(logInput);

 }


/***
 * function handleTextBox is called by the sideboard code when the user clicks on the "abc" button
 * It toggles the db.state between STATE_IN_ABC and STATE_NORMAL with each click
 * When starting the ABC it creates the createjs structures for the start of an abc text box
 * When already in ABC,it completes the ABC actions
 */
export function handleTextBox() {

  //console.log("handletextbox");

    if (db.state == STATE_VIEW_ONLY_FILE) { 
      return;
    }
  
    db.fileChanged = true;

    if (db.curProb == null) {
      cvControl(symConst.CV_CNTL_NEW_PROBLEM);
    }

    // check if within a grid-fraction, and if so exit from fraction
    if (db.curProb.fracState != STATE_NORMAL) {
      cvControl(symConst.CV_CNTL_ARROWRIGHT);
    }

    if (db.state == STATE_IN_ABC ) {  
                 
      db.state = STATE_NORMAL;   
      endABCText();
     
    } 
    else {
             
      // if interrupted any other problem states such as line or divide, clear them first
      if (db.probState != STATE_NORMAL)  {
        clearProbState();
      }
      db.state = STATE_IN_ABC;

      startABCText();
    }
  }
      
export function endABCText() {

    db.fileChanged = true;  
    let notEndLine = false;  
    let bounds;   
    let displayType = (db.mathLevel == 1 || db.mathLevel ==2 || db.lev3UseGrid) ? dConst.DISPLAY_TYPE_GRID : dConst.DISPLAY_TYPE_LINE;
    // if text was moved to different problem, or is on it's own problem, then reset db to prior problem
      // and clear any word-wrap box
      
      
      // check to see if no text was entered, if so, then delete and throw out this text box
      if (db.curText.textTyped == '' ) { 
        db.curText.container.removeAllEventListeners();
        db.curText.container.removeAllChildren();  // don't know if i need this
        db.curProb.container.removeChildAt(db.curText.container.myID);
        // if it was a seperate text problem, delete this problem
        // and start a new one at the same coordinates
        if (db.curProb.displayType == dConst.DISPLAY_TYPE_TEXT) {
          stage.removeChild(db.curProb.container);   
          db.mProb.splice(db.pIndex--,1);  
          startMProb(displayType);
        }
        doStageUpdate();
      }

      // otherwise  adjust the problem object display
      else {   
       
        // first turn off all listeners from moves/drags/wraps
        if (db.curText.wrapDot != null) {
          db.curText.wrapDot.removeAllEventListeners(); 
          db.curText.container.removeAllEventListeners(); 
          db.curText.container.removeChild(db.curText.wrapDot);

        }

        // first check for if the user entered this abc at start of new problem,
        // If so then change the problem with and displays
        if ( db.curProb.displayType == dConst.DISPLAY_TYPE_TEXT) {
          db.curProb.width = db.curProb.w = db.curText.w;
          db.curProb.h = db.curText.h;
          db.curProb.xpos = db.curProb.container.x + db.curProb.halfGW;
          db.curProb.ypos = db.curProb.container.y + db.curProb.halfGH;
          //hideGridShape();
          //drawCursor();   // hides the cursor since at text box problem
        }

        // push this text symbol onto it's problems textSymList
        // this helps manage the display when moving between problems in hidegrid
        db.mProb[db.curText.pIndex].textSymList.push(db.curText);
        
        // then add the text symbol to the current problem 
        // if it wasn't already added to a text problem
        
        // Determine if the text is located within a DISPLAY_TYPE_GRID problem
        // This happens if the text box wasn't moved in watchABCMouse and it 
        // wasn't the first symbol added to the problem  
        // If this is true then need to calculate the length of the text in grid units
        // and add null symbol objects to grid so everything stays lined up
        if (db.curProb.displayType == dConst.DISPLAY_TYPE_LINE) {
          bounds = db.curText.textToDraw.getBounds();
          let unitCount = bounds.width/ db.curProb.gridW;
          //console.log(unitCount, bounds.width);
          newTreeSym(db.curText.textTyped,symConst.CV_LONG_GRP,symConst.CV_TEXT_TO_LINE,unitCount);
          db.curText.container.removeAllChildren();
          doStageUpdate();
            
        }

        else if (db.curProb.displayType == dConst.DISPLAY_TYPE_GRID) {

          // if inserting into the grid, then adjust the sIndex back to get the right position
          if (db.curLine.sIndex < db.curLine.sym.length-1) {
            db.curLine.sym.splice(db.curLine.sIndex+1,0,db.curText);
            notEndLine = false;
          }
          else {
            db.curLine.sym.splice(db.curLine.sIndex+1,0,db.curText);
          }
          db.curLine.sIndex++;

          bounds = db.curText.textToDraw.getBounds();
          // calculate how many grid width units to allocate for this text 
          let boxCount = (Math.trunc((bounds.width+db.curProb.halfGW)/db.curProb.gridW)) +1;
          let boxWidth = boxCount * db.curProb.gridW;
         
          //redraw Textbox to be gridWidth increment
          db.curText.container.removeChild(db.curText.box);  // remove last textbox shape
          db.curText.box.mouseEnabled = false;               // disable mouse so as to not interferre with problem level drags
          db.curText.container.mouseEnabled = false;
          db.curText.box = drawOneABCBox(db.curText.container,boxWidth,db.curProb.gridH,'grey',dConst.ABC_BOX_INACTIVE_STROKE,"white",0); 
         
         
          // create null grid boxes to fill remainder of space so grid keeps lined up
          for (let i = db.curLine.sIndex; i < (db.curLine.sIndex+boxCount-1); i++) {
            spliceOneNullSym(symConst.CV_TEXT_FILL);
          }
          
           // check to see if at end of line, if not, move over rest of line
          if (!notEndLine) {
            moveOverGridText(db.curLine, db.curLine.sIndex+1, boxWidth); 
            db.curProb.width = Math.max(db.curProb.width, db.curLine.sym.length);
            //db.curLine.sIndex++;  
          }
       
                  
          // adjust xpos and line indexes to after the text problem
          db.curLine.sIndex += boxCount-1;
          db.xpos = db.curProb.xpos + (db.curLine.sIndex+1)*db.curProb.gridW;
          drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
          doStageUpdate(); 

          if (!notEndLine) {
            drawProbShapes(db.curProb.width+1, db.curProb.line.length);
          }

          let logInput = new dConst.CanvasInput("Done ABC", db.curText.textTyped);
          db.userLog.input.push(logInput);
        } 
        
        else {
          // text type problem
          // if textbox is null it means it was deleted after a wordwrap to 
          // work around a createjs bug, so redraw it
          if (db.curText.box == null) {
            db.curText.box = drawOneABCBox(db.curText.container,db.curText.w, db.curText.h,'orange',dConst.ABC_BOX_INACTIVE_STROKE,"white",0); 
            //watchABCMouseEvents(db.curText);
          }
        }
        // call makeProbSelected to create background box for problem drag and scale
        // will then change to another problem in the next step
        if (db.curProb.displayType == dConst.DISPLAY_TYPE_TEXT) {
          db.curText.container.removeChild(db.curText.box);
          db.curText.box = null; 
          drawProbShapes(db.curText.w,db.curText.y)

          // if this text box is in it's own problem now, then make active
          // the prior problem since can't add symbols to text boxes 
        
          // changedt to use -1 as flag to indicate should make new problem after text type problem
          //if (db.curText.pIndex != db.curText.pIndexReturn) 
            if (db.curText.pIndexReturn == -1 ) {     //|| db.mProb[db.curText.pIndexReturn].displayType == dConst.DISPLAY_TYPE_TEXT) {
              db.ypos = db.curProb.container.y + db.curText.h + db.curProb.gridH;       //  db.curText.h + db.curProb.gridH;
              db.xpos = db.curProb.container.x + db.curProb.halfGW;    //- db.curProb.gridW;
              startMProb(displayType);
         
            }
            else {
              //db.ypos += db.curText.h + db.gridHeight;
              makeProbSelected(db.curText.pIndexReturn);
              drawCursor(findProbEndX(db.curProb)+db.curProb.xpos-db.curProb.halfGW, 
                          findProbEndY(db.curProb)+db.curProb.ypos-db.curProb.halfGH);
            }

           
          //}
        }

      // call the file saver in order to create an undo stack object for this abc text
      cvGetDataUndoPush();
        
      }
      
      
    }

  // START ABC HALF STARTS HERE
  // Process the start of an ABC action here
  //  Turn on listener, create text box
  function startABCText(fromIpad) { 
    
      drawCursor();  // hide the current cursor
      let displayType = (db.mathLevel == 1 || db.mathLevel ==2) ? dConst.DISPLAY_TYPE_GRID : dConst.DISPLAY_TYPE_LINE;

      // check for this being the first thing a user enters
      // create a null problem if so
      if (db.curProb == null ) {
        startMProb(displayType);
      }
      // check if current problem is text type, if so then start new problem instead
      else if (db.curProb.displayType == dConst.DISPLAY_TYPE_TEXT) {
          let lastpIndex = findLastProb();
          if (lastpIndex > -1) {
            db.ypos += db.curProb.gridH*2;
            checkPosForPageAdd()
            startMProb(db.displayType);
          }
        }

       // create a new symbol object of type symbol text to hold all the ABC box fields
      // right now don't assign it to a problem, instead save in db.curText and display on top
      // At end of ABC or if user drags box, then it will get assigned to problem  
      createNewTextObjs();
  
      // save the pIndex of either the current problem, or the last one with symbols
      // used to return too after abc is done
      db.curText.pIndexReturn = (db.curProb.width == 0) ? -1: db.pIndex;
      db.curText.pIndex = db.pIndex; 
      
      // set up initial size for first time
      db.curText.w = db.curProb.gridW*2;
      db.curText.h = db.curProb.gridH;
     

      // check if user is in a new problem,  if so, then convert that problem to a text type
     
      if (db.curProb.width == 0) {
        db.curProb.displayType = dConst.DISPLAY_TYPE_TEXT;
        hideGridShape(db.curProb);
       
       
        // just put in a start value so that it won't be considered a blank problem if user clicks off it before abc done
        db.curProb.width = db.curProb.gridW;  
        db.curText.wrapAllowed =  true; 
        db.curLine.sym.push(db.curText);
        db.curLine.sIndex++;
        drawCursor(); // hides cursor
      }
   
      // Draw an initial textBox for the user to add text to
      db.curText.box = drawOneABCBox(db.curText.container,db.curProb.gridW*2,db.curProb.gridH,"green",dConst.ABC_BOX_ACTIVE_STROKE,"white",0);
      doStageUpdate();

      // set up the text box to be able to drag
      if (!fromIpad) {
        watchABCMouseEvents(db.curText);
      }
    
      let logInput = new dConst.CanvasInput("abc started", "pIndex" + db.pIndex);
      db.userLog.input.push(logInput);

      // further actions during ABC will be done by event handlers, and when user clicks ABC again
    
  }
  
  /****
   *  funtion drawOneABCBox draws a single createjs rectangle as an ABC text box
   *  This createjs shape is returned, and added as child to curText.container
   */
  export function drawOneABCBox(container, boxWidth,boxHeight,color,stroke,fill,index) {
  
    let textBox = new createjs.Shape();
    textBox.graphics.beginStroke(color).setStrokeStyle(stroke).beginFill(fill);
    textBox.graphics.rect(0,0,boxWidth,boxHeight);
    textBox.x = 0;      // boxes around text are always offset by half gridwidth 
    textBox.y = 0;   // to compensate for difference in starting location of text vs shapes
    //textBox.width = boxWidth;
    db.curText.w = boxWidth;
    db.curText.h = boxHeight;
    
    //if (index == null)  {   // if index was passed, add box there, otherwise put next in list
    //  db.curText.container.addChild(textBox);    // maybe a global object with these things
    //}
    //else {
      container.addChildAt(textBox,0); 
   // }
    
    doStageUpdate();
    return textBox;
  }
   
function createNewTextObjs() {

  db.curText = new SymbolText("",symConst.KEY_ID_ABC);  // put this key id in to distinguish from keyboard keys

  // make new createjs objects for the abc text
  let tempContainer = new createjs.Container();
  db.curText.container = tempContainer;
  let point = convertXYforABCBox();
  db.curText.container.x = point.x; //db.xpos - db.curProb.xpos;    //(db.curLine.sIndex+1)*db.curProb.gridW;
  db.curText.container.y = point.y; //db.ypos - db.curProb.ypos;        //db.curProb.lIndex*db.curProb.gridH;
  db.curText.container.name = dConst.CREATEJS_NAME_ABC_TEXT;

  db.curProb.container.addChild(db.curText.container);
  db.curText.container.myID =  db.curProb.container.getChildIndex(db.curText.container);
}
/***
 * function watchABCMouseEvents watches the current textBox only for a drag event
 * In this way a user can tear off an ABC text box and make it a seperate problem
 * ABC text has to be a separate problem to be able to word wrap, as can't do this in grid
 */ 
export function watchABCMouseEvents(textSym) {

    let w,h;
    //console.log("WatchABCMouse called");

    textSym.box.addEventListener('mousedown',function (e) {
      e.preventDefault();
      e.stopPropagation();

      let startX = stage.mouseX/stage.scaleX;
      let startY = stage.mouseY/stage.scaleY;
      let startProbX = textSym.container.x;
      let startProbY = textSym.container.y;
      let offSetX = startX - db.curProb.container.x - startProbX;
      let offSetY = startY - db.curProb.container.y - startProbY;

      let mouseX, mouseY;

      //clickABCTimer = setTimeout(checkABCLongClick,2000);
      let state = STATE_NORMAL;
      
      stage.enableMouseOver(30); 

      // Once a pressdown has been detected, watch for drag and pressup events
      textSym.box.addEventListener('pressmove', function (e) {
        e.preventDefault();
        e.stopPropagation();  
       
        // Detected drag/pressmove, so 
        // keep adjusting the object x,y throughout drag
        state = STATE_ABC_DRAG;
        db.fileChanged = true;  
        mouseX = stage.mouseX/stage.scaleX;
        mouseY = stage.mouseY/stage.scaleX;
        textSym.container.x = mouseX -  startX + startProbX; 
        textSym.container.y = mouseY -  startY + startProbY; 
        
       
        doStageUpdate();
     
      }); 
  
      // create event listener for pressup to end drag/drop and watch for mouse clicks and long clicks
      textSym.box.addEventListener('pressup', function (e) {
        //console.log(textSym.container.x, textSym.container.y, startX, startProbX, db.xpos, db.ypos,offSetX, offSetY);
        e.preventDefault();
        e.stopPropagation();
        
        db.xpos = mouseX -  offSetX + db.curProb.halfGW;
        db.ypos = mouseY -  offSetY + db.curProb.halfGH;
       
        doStageUpdate();

        textSym.box.removeAllEventListeners('pressmove');
        textSym.box.removeAllEventListeners('pressup');

        // if the user dragged to move this text, then 
        // check if this abc text was part of a grid problem before
        // If it was, then create a new problem and add the text to it.  
        if (state == STATE_ABC_DRAG ) {
          state == STATE_NORMAL;
          //db.xpos = textSym.container.x+ db.curProb.halfGW;   // adding the half to keep xpos as typically done, but watch for curProb issues
          //db.ypos = textSym.container.y + db.curProb.halfGH;

          // if there are no prior symbols on the problem, then convert this problem to a text-type
          if (db.mProb[textSym.pIndex].displayType == dConst.DISPLAY_TYPE_GRID || 
              db.mProb[textSym.pIndex].displayType == dConst.DISPLAY_TYPE_LINE) {
            //db.ypos -= db.curProb.halfGH;
            textSym.container.x = textSym.container.y = 0;
            convertABCToProb(textSym);
          }
          else {
            db.mProb[textSym.pIndex].xpos = db.xpos;  // check pos, might not want this here
            db.mProb[textSym.pIndex].ypos = db.xpos;
            db.mProb[textSym.pIndex].container.x += textSym.container.x;
            db.mProb[textSym.pIndex].container.y += textSym.container.y;
            textSym.container.x = textSym.container.y = 0;
            
          }
          doStageUpdate();

          let logInput = new dConst.CanvasInput("ABC moved", "x" + textSym.container.x + "y" + textSym.container.y);
          db.userLog.input.push(logInput);   
        } 
        
      });
    });  
}  
  
export function convertABCToProb(textSym) {

  db.curProb.container.removeChild(db.curText.container);
  let oldIndex = textSym.pIndex;
  //console.log(db.curProb);

  startMProb(dConst.DISPLAY_TYPE_TEXT);
  textSym.pIndexReturn = oldIndex;

  db.curText.container.removeChild(db.curText.box);
  db.curText.box = drawOneABCBox(db.curText.container,db.curText.w,db.curText.h, dConst.ABC_BOX_ACTICE_COLOR, 
                                  dConst.ABC_BOX_ACTIVE_STROKE,"white",0);

  // add curtext container back once the curProb has been changed by startMProb
  db.curProb.container.addChild(db.curText.container)
  db.curProb.width = db.curText.w;
  db.curLine.sym.push(db.curText);
  db.curLine.sIndex++;
  db.curText.pIndex = db.pIndex;
  db.curProb.h = db.curText.h;
  db.curProb.w = db.curText.w;
  drawCursor();  // hide cursor
  

  // the first time it is moved, then turn on the word wrap watcher
  // and move this to a new problem
  if (!textSym.wrapAllowed) {
    textSym.wrapAllowed = true;
    watchABCWordWrap(db.curText);
  }

}

export function watchABCWordWrap(textSym,leftWrap) {

    let w,h, wrapBox;
    let wasMoved = false;

    textSym.container.mouseEnable = true;
    textSym.box.mouseEnable = true;
   

    // Create a word wrap area at bottom to textBox for user to drag in order to change the
    // text box area to allow word wrapping
    // createjs does not allow text editing so this will only wrap the existing text entered.  
    // User has to enter more text afterward and then word wrap again to change it
    if (textSym.wrapDot != null) {
      //textSym.container.removeChild(textSym.wrapDot);
    }
    let wrapDot = new createjs.Shape();
    textSym.wrapDot = wrapDot;
    textSym.container.addChild(wrapDot);
    wrapDot.y = db.curProb.halfGH;
    wrapDot.graphics.beginFill("white").beginStroke("green").drawCircle(0,0,dConst.SCALE_DOT_SIZE/stage.scaleX);
          
    wrapDot.cursor = "col-resize";
    if (leftWrap) {
      wrapDot.x = 0;
    }
    else { 
      wrapDot.x = textSym.w;
    }
    doStageUpdate();

    // listen for initial mouse press on wrap button
    wrapDot.addEventListener('mousedown',function (e) {
      
      //textSym.container.removeChild(textSym.box);

      //textSym.container.removeChild(textSym.box); 
      wrapBox = new createjs.Shape();
      textSym.container.addChildAt(wrapBox,0);
      //wrapBox.graphics.beginFill("white").beginStroke("blue").drawRect(0,0,textSym.w,textSym.h);

      let startX = stage.mouseX/stage.scaleX;
      let startY = stage.mouseY/stage.scaleY;  
      let startProbX = wrapDot.x;
      let startProbY = wrapDot.y;
      let endProbX = wrapDot.x + textSym.w;
      let endProbY = wrapDot.y + textSym.h;
     
      let state = STATE_NORMAL;
      
      // If got a mouse press, then watch for drag/pressmoves and pressup
      wrapDot.addEventListener('pressmove', function (e) {
       
          state = STATE_ABC_DRAG;
          //db.probState = STATE_ABC_WRAP;
          db.fileChanged = true;
          wasMoved = true;
          textSym.box.visible = false;
          wrapBox.visible = true;
        
          // during pressmove, continually adjst the position of the wrapdot, along
          // with the textbox size and textToDraw object width to word wrap
          if (leftWrap) {
            textSym.container.x =  stage.mouseX/stage.scaleX - startX; // + startProbX; // - textSym.container.x; //- textSym.box.x;    //  container.x -startX; 
            textSym.h = stage.mouseY/stage.scaleY- startY + startProbY; // - textSym.container.y; // - textSym.box.y;     //    container.y -startY; 
            textSym.w = endProbX - textSym.container.x;
          }
          else {    // doing right wrap dot
            textSym.w =  stage.mouseX/stage.scaleX - startX + startProbX; 
            textSym.h = stage.mouseY/stage.scaleY- startY + startProbY; 
            wrapDot.x = textSym.w;
          }
          wrapDot.y = textSym.h;
            //textSym.container.removeChild(textSym.box); 
            //textSym.box = new createjs.Shape();
         
          
          //textSym.container.addChildAt(textSym.box,0);
          db.curText.textToDraw.lineWidth = textSym.w;

          let bounds = db.curText.textToDraw.getBounds();
          
          textSym.h = bounds.height + db.curProb.gridH/4;
          wrapBox.graphics.clear().beginFill("white").beginStroke("green").drawRect(0,0,textSym.w,textSym.h);

          textSym.wrapStarted = true;
          doStageUpdate();
      }); 
     
      // create event listener for pressup to end drag/drop and watch for mouse clicks and long clicks
      //stage.addEventListener('stagemouseup', function (e) {
        wrapDot.addEventListener('pressup', function (e) {
          wrapDot.removeAllEventListeners('pressmove');
          wrapDot.removeAllEventListeners('pressup');

          if (wasMoved) {
            textSym.box.graphics.clear().beginFill("white").beginStroke("green").drawRect(0,0,textSym.w,textSym.h);
            textSym.box.visible = true;
            db.curProb.w = textSym.w;
            db.curProb.h = textSym.h;
           
            if (leftWrap) {
              db.curProb.container.x += textSym.container.x;
              db.curProb.container.y += textSym.container.y;
              textSym.container.x = textSym.container.y = 0;
            }
            let logInput = new dConst.CanvasInput("ABC wrap", "w" + textSym.w + "h" + textSym.h);
            db.userLog.input.push(logInput);
          }
          //textSym.container.removeChild(wrapBox);
          wrapBox.visible = false;
          //textSym.box = null;
          doStageUpdate();
          

      // if the user dragged to move this text, then they are creating a new problem with it.  
      if (state == STATE_ABC_DRAG ) {
        // switch to the new box if the user did a word wrap drag
        // this needed because createjs doesn't clear prior box drawing otherwise
        state = STATE_NORMAL;
      } 
    
      });
    });
   
  }  
  

 
/** 
/* This is the event handler routine for accepting keyboard keys during the time of an "abc' test event. 
*/

export function pressedKey(e,textStr,cvDelete,cvDeleteProb) {

  //console.log(e,textStr);

  // throw out any data when in view only mode
  if (db.state == STATE_VIEW_ONLY_FILE) { 
    return;
  }

  let isDelete = false; 
  if (cvDelete == true) {
    isDelete = true;
  }  
  let isNewLine = false;
  
    // check that this is a a key press event, and not an ipad string being passed in
     // throw out any keyboard control keys except delete/backspace, or enter keys (these will have greater>1 length), 
    // plus throw out delete backspace if it's the first abc key entered
    // first section adjust the texttyped string to have the right text
    if (e != null) {
      isDelete = (e.keyCode === dConst.KEY_CODE_DELETE || e.keyCode === dConst.KEY_CODE_BACKSPACE);
      isNewLine = e.keyCode === dConst.KEY_CODE_ENTER;
    }
    else if (!cvDelete) {
      // if in ipad and text type, then count the newlines
      if (db.curProb.displayType == dConst.DISPLAY_TYPE_TEXT) {
        db.curText.lineCount = countNewLines(textStr);
      }
      // if in ipad and grid type, then remove newlines from string
      else {
        textStr = removeNewLines(textStr);
      }
    }
    
    // if user clicked a delete problem while in abc mode, then just delete string
    // later coordination with sideboard should be added
    if (cvDeleteProb) {
      db.curText.textTyped = "";
    }
    // if it's a delete then remove one character from textTyped string
    else if ((isDelete || cvDelete) && db.curText.textTyped.length > 0) {
      db.curText.textTyped = db.curText.textTyped.slice(0,db.curText.textTyped.length-1);
    }
    // if it's an enter key then add a new line character to the string
    else if (e != null && isNewLine && db.curText.wrapAllowed) {
      db.curText.textTyped = db.curText.textTyped + '\n';  
      db.curText.lineCount++;
    }
    //throw out other control characters and return out of routine
    else if (e != null && e.key.length > 1) {
      return;
    }
    // if regular key was entered then add this to to textType listed
    else if (e != null) {   
        db.curText.textTyped = db.curText.textTyped + e.key;    // add key to current text string
    }
    // or if from an ipad string, use the whole string
    else {
      db.curText.textTyped = textStr;
    }
     
     // if not first character, delete prior text string from display and cancel handlers      
    if (db.curText.container != null) {      
          db.curText.container.removeAllEventListeners();
          db.curText.container.removeChild(db.curText.textToDraw);
    }
    // otherwise check the problem type to see if it can be word wrapped 
    else if (db.curProb.width == 0 && db.curProb.displayType == dConst.DISPLAY_TYPE_GRID) {
        //  hideGridShape();
    }
    
     // print new text by creating a new createjs text object, as long as haven't deleted back to a zero length string
     // and figure out the right w and h and linewidth and lineheights
    if (db.curText.textTyped.length > 0) {  
        db.curText.textToDraw = new createjs.Text(db.curText.textTyped, 
                                getSymFont(symConst.KEY_ID_1,symConst.CV_NUM_TYPE),db.userPrefs.cvTextColor);
        db.curText.textToDraw.x = db.curProb.gridW/4; // -db.gridWidth/4;  // check later
        db.curText.textToDraw.y = db.curProb.halfGH;
        db.curText.textToDraw.textAlign = 'left';
        db.curText.textToDraw.textBaseline = 'middle';
        db.curText.textToDraw.mouseEnabled = false;
        
        
        //curText.container.addChild(textToDraw);
        //doStageUpdate();
       
         
        //else if (e != null && e.key == ' ') {
        //  db.curText.w = db.curText.w + db.curProb.halfGW;
        //}
        //else {  
          // get bounds to tell text length as long as the last key wasn't a space 
        let bounds = db.curText.textToDraw.getBounds();
        if (db.curProb.displayType == dConst.DISPLAY_TYPE_GRID || db.curProb.displayType == dConst.DISPLAY_TYPE_LINE) {
          //else if (e != null && e.key == ' ') {
        //  db.curText.w = db.curText.w + db.curProb.halfGW; 
          db.curText.w = bounds.width + db.curProb.gridW;
          //db.curText.h = db.curProb.gridH; should be set already but check
        }
        else {

           // db.curText.h = Math.max(db.curProb.gridH, bounds.height+db.curProb.halfGH);
        
          let spaceAvail = (stage.canvas.width/stage.scaleX-5) - db.curProb.container.x;
          let lineHeight = db.curText.textToDraw.getMeasuredLineHeight();
          db.curText.textToDraw.lineHeight = lineHeight*1.3;
          
          if (db.curText.wrapStarted) {
            db.curText.w = Math.min(bounds.width + db.curProb.gridW,db.curText.w);
          } 
          else {
            db.curText.w = bounds.width + db.curProb.gridW;
          }
            if (db.curText.w > spaceAvail) { 
         
            let numLines = Math.trunc(db.curText.w/spaceAvail);
            if (!db.curText.edgeWrapped) {
              db.curText.lineCount += numLines; // lineCount will already include 1st line
            }
            db.curText.h = db.curText.lineCount * db.curText.textToDraw.lineHeight; //+ lineHeight/2;
            db.curText.w = spaceAvail; 
            db.curText.textToDraw.lineWidth = spaceAvail;
            db.curText.edgeWrapped = true;
                      }
          else {
            db.curText.textToDraw.lineWidth = db.curText.w;
          }
          bounds = db.curText.textToDraw.getBounds();
          db.curText.h = bounds.height + db.curText.lineCount*lineHeight/2; //db.curText.lineCount * db.curText.textToDraw.lineHeight + lineHeight/2;
                    //}

        }
        // use wrapDot to determine if wraps have been active
        if (db.curText.wrapStarted) {
         
          db.curText.container.removeChild(db.curText.box);  // remove last curText.box shape
          db.curText.box = drawOneABCBox(db.curText.container, db.curText.w, 
                         db.curText.h, "green",dConst.ABC_BOX_ACTIVE_STROKE,'white',0);         
          db.curText.container.addChild(db.curText.textToDraw);   // Add this after box to get top-to-bottom order right
        }
        // if this is the first character of text starting as seperate problem, start watch wrap
        else if (db.curText.wrapAllowed) {
          if (db.curText.wrapDot != null) {
            db.curText.wrapDot.removeAllEventListeners();
            db.curText.container.removeChild(db.curText.wrapDot); 
          }
          db.curText.container.removeChild(db.curText.box);  // remove last curText.box shape
          db.curText.box = drawOneABCBox(db.curText.container, db.curText.w, db.curText.h, "green",dConst.ABC_BOX_ACTIVE_STROKE,'white',0);
          db.curText.container.addChild(db.curText.textToDraw);
          if (e != null) {
            watchABCWordWrap(db.curText);
          }
          // if from an ipad abc call, use a left side word wrap, indicated by the true parameter
          else {
            watchABCWordWrap(db.curText,true);
          }
         
        }
        // if no word wrap allowed then just draw the text boxes
        else { 
          db.curText.container.removeChild(db.curText.box);  // remove last curText.box shape
          db.curText.box = drawOneABCBox(db.curText.container,db.curText.w, db.curText.h, "green",dConst.ABC_BOX_ACTIVE_STROKE,'white',0);
  
          db.curText.container.addChild(db.curText.textToDraw);   // Add this after box to get top-to-bottom order right
        }
        
        // since changed the createjs boxes and cancelled prior listeners, need to restart drag text watcher
        watchABCMouseEvents(db.curText);
      }
      doStageUpdate();
        
    }

  